import { SCROLL_MARGIN_TOP } from '@dtx-company/true-common/src/constants/layout'

export const addScrollMarginTop = (elementId?: string): void => {
  const scrollTo = elementId && document.getElementById(elementId)
  if (scrollTo) {
    scrollTo.style.scrollMarginTop = `${SCROLL_MARGIN_TOP}px`
  }
}
